/**
 * Error codes for i18n-friendly error handling.
 * Frontend translates these codes to localized messages.
 *
 * Format: CATEGORY_ACTION_REASON
 *
 * Categories: AUTH, USER, ROLE, VALIDATION, STORAGE, PERMISSION, RESOURCE, SYSTEM
 */
export const ErrorCodes = {
  // Auth
  AUTH_INVALID_CREDENTIALS: 'AUTH_INVALID_CREDENTIALS',
  AUTH_TOKEN_EXPIRED: 'AUTH_TOKEN_EXPIRED',
  AUTH_TOKEN_INVALID: 'AUTH_TOKEN_INVALID',
  AUTH_TOKEN_REQUIRED: 'AUTH_TOKEN_REQUIRED',
  AUTH_OTP_REQUIRED: 'AUTH_OTP_REQUIRED',
  AUTH_OTP_INVALID: 'AUTH_OTP_INVALID',
  AUTH_REFRESH_TOKEN_REQUIRED: 'AUTH_REFRESH_TOKEN_REQUIRED',
  AUTH_REFRESH_TOKEN_INVALID: 'AUTH_REFRESH_TOKEN_INVALID',
  AUTH_REFRESH_TOKEN_EXPIRED: 'AUTH_REFRESH_TOKEN_EXPIRED',
  AUTH_SESSION_NOT_FOUND: 'AUTH_SESSION_NOT_FOUND',
  AUTH_SESSION_SELF_REVOKE: 'AUTH_SESSION_SELF_REVOKE',
  AUTH_VERIFICATION_CODE_INVALID: 'AUTH_VERIFICATION_CODE_INVALID',
  AUTH_REGISTRATION_DISABLED: 'AUTH_REGISTRATION_DISABLED',
  AUTH_AUTO_CREATE_DISABLED: 'AUTH_AUTO_CREATE_DISABLED',

  // User
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  USER_EMAIL_EXISTS: 'USER_EMAIL_EXISTS',
  USER_NOT_AUTHENTICATED: 'USER_NOT_AUTHENTICATED',

  // Role
  ROLE_NOT_FOUND: 'ROLE_NOT_FOUND',
  ROLE_NAME_EXISTS: 'ROLE_NAME_EXISTS',
  ROLE_SYSTEM_PROTECTED: 'ROLE_SYSTEM_PROTECTED',
  ROLE_HAS_USERS: 'ROLE_HAS_USERS',
  ROLE_DEFAULT_NOT_FOUND: 'ROLE_DEFAULT_NOT_FOUND',

  // Permission
  PERMISSION_DENIED: 'PERMISSION_DENIED',

  // Validation
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  VALIDATION_FIELD_REQUIRED: 'VALIDATION_FIELD_REQUIRED',
  VALIDATION_FIELD_INVALID: 'VALIDATION_FIELD_INVALID',
  VALIDATION_JSON_MALFORMED: 'VALIDATION_JSON_MALFORMED',

  // Storage
  STORAGE_FILE_NOT_FOUND: 'STORAGE_FILE_NOT_FOUND',
  STORAGE_FILE_TOO_LARGE: 'STORAGE_FILE_TOO_LARGE',
  STORAGE_FILE_TYPE_NOT_ALLOWED: 'STORAGE_FILE_TYPE_NOT_ALLOWED',
  STORAGE_PAYLOAD_TOO_LARGE: 'STORAGE_PAYLOAD_TOO_LARGE',
  STORAGE_ERROR: 'STORAGE_ERROR',

  // Resource (generic)
  RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
  RESOURCE_CONFLICT: 'RESOURCE_CONFLICT',
  RESOURCE_CREATE_NOT_SUPPORTED: 'RESOURCE_CREATE_NOT_SUPPORTED',
  RESOURCE_UPDATE_NOT_SUPPORTED: 'RESOURCE_UPDATE_NOT_SUPPORTED',
  RESOURCE_DELETE_NOT_SUPPORTED: 'RESOURCE_DELETE_NOT_SUPPORTED',

  // Module
  MODULE_NOT_FOUND: 'MODULE_NOT_FOUND',

  // HTTP standard
  NOT_FOUND: 'NOT_FOUND',
  AUTH_UNAUTHORIZED: 'AUTH_UNAUTHORIZED',

  // Database
  DB_CONSTRAINT_UNIQUE: 'DB_CONSTRAINT_UNIQUE',
  DB_CONSTRAINT_FK: 'DB_CONSTRAINT_FK',
  DB_CONNECTION_ERROR: 'DB_CONNECTION_ERROR',
  DATABASE_NOT_READY: 'DATABASE_NOT_READY',

  // System
  SYSTEM_INTERNAL_ERROR: 'SYSTEM_INTERNAL_ERROR',
} as const

export type ErrorCode = typeof ErrorCodes[keyof typeof ErrorCodes]
